module.exports = __webpack_public_path__ + "img/waiting-for-email.6feeb495.jpg";